import React, { Component } from 'react';
import { withTheme } from 'emotion-theming';
import { DarkButton } from '@lyearn-team/frontend-components';
import styles from './styles';

@withTheme
class DarkAccentTextView extends Component {
  render() {
    const { theme, handleClick } = this.props;
    return (
      <DarkButton.TextButton className={styles.darkAccentTextView(theme)} onClick={handleClick}>
        View Certificate
      </DarkButton.TextButton>
    );
  }
}

export default DarkAccentTextView;
